<lipp-info-page
  *ngIf="!context"
  [isLoading]="isLoading"
  [icon]="errorTitle ? 'far fa-face-frown' : undefined"
  [title]="errorTitle"
  [description]="errorDescription"
></lipp-info-page>

<div *ngIf="context" id="oauth-consent-wrapper">
  <img id="logo" src="/assets/logos/logo.svg" />

  <div id="oauth-consent-card">
    <i class="far fa-robot app-icon"></i>

    <h1>
      {{ "OAuthConsent.Title" | translate : [context.clientName] }}
    </h1>

    <p class="redirect">
      {{ "OAuthConsent.RedirectHost" | translate : [context.redirectHost] }}
    </p>

    <p *ngIf="context.isLoopbackRedirect" class="hint warning">
      <i class="fas fa-triangle-exclamation"></i>
      <span>{{ "OAuthConsent.LoopbackWarning" | translate }}</span>
    </p>

    <div class="section">
      <label>{{ "OAuthConsent.Account" | translate }}</label>
      <span>{{ context.loginName }}</span>
    </div>

    <div class="section">
      <label>{{ "OAuthConsent.Permissions" | translate }}</label>

      <ul>
        <li>
          <i class="far fa-eye"></i>
          <span>{{ "OAuthConsent.Scopes.Read" | translate }}</span>
        </li>
        <li>
          <i class="far fa-pen-slash"></i>
          <span>{{ "OAuthConsent.Scopes.NoWrite" | translate }}</span>
        </li>
      </ul>
    </div>

    <p *ngIf="context.isLineckerAccount" class="hint">
      <i class="far fa-circle-info"></i>
      <span>{{ "OAuthConsent.LineckerAccount" | translate }}</span>
    </p>

    <p class="revoke">{{ "OAuthConsent.RevokeInfo" | translate }}</p>

    <div class="buttons">
      <button type="button" class="secondary" [disabled]="isSubmitting" (click)="deny()">
        {{ "OAuthConsent.Deny" | translate }}
      </button>

      <button type="button" class="success" [disabled]="isSubmitting" (click)="allow()">
        <lipp-loading-spinner *ngIf="isSubmitting" [scale]="0.4"></lipp-loading-spinner>
        <ng-container *ngIf="!isSubmitting">{{ "OAuthConsent.Allow" | translate }}</ng-container>
      </button>
    </div>
  </div>
</div>
